module.exports = __webpack_public_path__ + "static/media/ehealth_pro_feature_2.eb87456e.png";